__turbopack_context__.v({
  "contactMethods": "ContactDetailsDialog-module__0bgpra__contactMethods",
  "error": "ContactDetailsDialog-module__0bgpra__error",
  "fieldLabel": "ContactDetailsDialog-module__0bgpra__fieldLabel",
  "form": "ContactDetailsDialog-module__0bgpra__form",
  "tagList": "ContactDetailsDialog-module__0bgpra__tagList",
});
